// extracted by mini-css-extract-plugin
export var actions = "_mi-d";
export var benefitCard = "_mi-a";
export var benefitIcon = "_mi-b";
export var benefitLabel = "_mi-c";
export var benefits = "_mi-9";
export var bodyText = "_mi-8";
export var closeButton = "_mi-2";
export var content = "_mi-3";
export var eyebrow = "_mi-4";
export var heading = "_mi-5";
export var image = "_mi-f";
export var imagePanel = "_mi-e";
export var modal = "_mi-0";
export var shell = "_mi-1";
export var title = "_mi-6";
export var titleOffer = "_mi-7";